import store from "@/store";
import Vue from "vue";

let full_access = ["create", "read", "update", "delete"];

const can = (module = "") => {
  let roles = store.getters["auth/roles"];
  let account = store.getters["auth/account"];
  let permissions = [];
  switch (module) {
    case "tickets":
      if (roles.includes("service/tickets_view_only")) 
          permissions = ["read"];
      if ((roles.includes("service/tickets_full_access") || roles.includes("admin")) &&
          account.current.enable_service)
          permissions = full_access;
      break;

    case "contacts":
      if (roles.includes("service/contacts_view_only")) 
          permissions = ["read"];
      if ((roles.includes("service/contacts_full_access") || roles.includes("admin")) &&
          account.current.enable_service)
          permissions = full_access;
      break;
    case "supportemail":
      if ((roles.includes("service/support_email") || roles.includes("admin")) &&
          account.current.enable_service)
          permissions = full_access;
      break;
  }
  return permissions;
};

Vue.prototype.$can = (action = "", subject = "") => {
  subject = subject.toLowerCase();
  action = action.toLowerCase();

  return can(subject).includes(action);
};
